window.YkMultipackDiscount = (() => {
  const toNumber = (value) => {
    const parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : 0;
  };

  const getSchema = (item) => {
    const productSchema = item?.product?.metafields?.custom?.multipack_discount_schema;
    if (productSchema && typeof productSchema === 'object' && Object.keys(productSchema).length > 0) {
      return productSchema;
    }

    const schema = window.ykMultipackDiscountSchema;
    return schema && typeof schema === 'object' ? schema : null;
  };

  const isMultipackItem = (item) => Boolean(item?.product?.metafields?.custom?.multipack_settings);

  const getDiscountPercentForQty = (item, quantity) => {
    const schema = getSchema(item);
    if (!schema) return null;

    const percent = toNumber(schema[String(quantity)]);
    return percent > 0 ? percent : null;
  };

  const getItemVariant = (item) => {
    const variants = item?.product?.variants;
    if (!Array.isArray(variants) || variants.length === 0) return null;

    const variantId = toNumber(item?.variant_id);
    return variants.find((variant) => toNumber(variant?.id) === variantId) || null;
  };

  const getVariantOriginalPriceCents = (item) => {
    const variant = getItemVariant(item);
    if (typeof variant?.price !== 'string') return null;

    const normalized = variant.price.replace(',', '.').trim();
    if (!normalized) return null;

    const amount = Number(normalized);
    if (!Number.isFinite(amount) || amount <= 0) return null;

    return Math.round(amount * 100);
  };

  const get = (item) => {
    if (item?.selling_plan_allocation) return null;
    if (!isMultipackItem(item)) return null;

    const quantity = Math.max(1, toNumber(item?.quantity));
    const percent = getDiscountPercentForQty(item, quantity);
    if (!percent) return null;

    const originalUnitCents = getVariantOriginalPriceCents(item);
    if (!originalUnitCents) return null;

    const originalLineCents = originalUnitCents * quantity;
    const currentLineCents = toNumber(item?.final_line_price);
    const discountCents = originalLineCents - currentLineCents;
    if (discountCents <= 0) return null;

    return { percent, originalUnitCents, originalLineCents, currentLineCents, discountCents };
  };

  return { get, isMultipackItem, getDiscountPercentForQty };
})();
